export default "__VITE_ASSET__EEpEs3Se__"